import React from "react";
import { ShieldCheck } from "lucide-react";
import { Section, FadeUp, SectionHeading, CtaButton } from "./primitives";

export const Guarantee = () => (
  <Section className="bg-zinc-50">
    <div className="max-w-[720px] mx-auto">
      <FadeUp>
        <div className="bg-white border border-zinc-200 rounded-xl p-8 md:p-12 shadow-sm text-center">
          <ShieldCheck className="h-12 w-12 text-[#D90429] mx-auto" />
          <SectionHeading className="mt-4">The Guarantee</SectionHeading>
          <div className="mt-6 space-y-5 text-lg md:text-xl text-zinc-600 leading-relaxed">
            <p>Follow the plan for the first 30 days.</p>
            <p>Submit your practice videos and action the feedback you get.</p>
            <p>
              If you've done that, and you're still not seeing real progress, you'll get a full refund.
            </p>
          </div>
          <div className="mt-10 flex justify-center">
            <CtaButton testid="cta-guarantee-apply" />
          </div>
        </div>
      </FadeUp>
    </div>
  </Section>
);
